import { Formik as FormikDefault } from 'formik'
import * as React from 'react'

export default function Formik (props) {
  return (
    <FormikDefault
      {...props}
    />
  )
}
